<template>
  <AuthInput
    :id="id"
    :label="label"
    :icon="icon"
    :model-value="modelValue"
    :type="isVisible ? 'text' : 'password'"
    v-bind="$attrs"
    @update:model-value="emit('update:modelValue', $event)"
  >
    <template #trailing>
      <button
        type="button"
        class="auth-field__toggle"
        :title="isVisible ? $t('Hide password') : $t('Show password')"
        :aria-label="isVisible ? $t('Hide password') : $t('Show password')"
        @click="isVisible = !isVisible"
      >
        <component :is="isVisible ? EyeOff : Eye" :size="20" aria-hidden="true" />
      </button>
    </template>
  </AuthInput>
</template>

<script setup lang="ts">
import { ref, type Component } from "vue";
import { Eye, EyeOff } from "lucide-vue-next";
import AuthInput from "./AuthInput.vue";

defineOptions({ inheritAttrs: false });

defineProps<{
  id: string;
  label: string;
  icon: Component;
  modelValue: string;
}>();

const emit = defineEmits<{
  "update:modelValue": [value: string];
}>();

const isVisible = ref(false);
</script>
